module.exports = __webpack_public_path__ + "static/media/china.87d6c351.svg";